import React from 'react';
import styled from '@emotion/styled';

function calDescColor(ref) {
   if (ref === 'Active') return '#4ba23a';
   else if (ref === 'Inactive') return '#9e9e9e';
   else if (ref === 'Pending') return '#f98331';
   else if (ref === 'Expire') return '#da3a3c';
   else if (ref === 'Delete') return '#346b94';
   else return '#fb99ff';
}

function calcColor(ref) {
   if (ref === 1) return '#4ba23a';
   else if (ref === 2) return '#9e9e9e';
   else if (ref === 4) return '#346b94';
   else return '#da3a3c';
}
function calRewardColor(ref) {
   if (ref === 1) return '#51d600';
   else if (ref === 2) return '#005eff';
   else return '#ccc';
}

function caltActivityColor(ref) {
   if (ref === 'Inactive') return '#9e9e9e';
   else if (ref === 'Active') return '#4ba23a';
   else return '#f98331';
}

function calShippingColor(ref) {
   if (ref === 1) return '#ccc';
   else if (ref === 2) return '#ff8c00';
   else if (ref === 3) return '#00c4ff';
   else if (ref === 4) return '#9dff00';
   else if (ref === 5) return '#51d600';
   else return '#ff0000';
}
const ILabel = styled(`div`)`
   background-color: ${(props) =>
      props.StatusType === 'Success' ? '#4ba23a' : '#da3a3c'};
   color: #fff;
   font-size: smaller;
   font-family: GSB;
   text-align: center;
   border-radius: 2.5px;
   max-width: 60px;
   display: flex;
   justify-content: center;
`;
const Label = styled(`div`)`
   background-color: ${(props) => calcColor(props.StatusType)};
   color: #fff;
   font-size: smaller;
   font-family: GSB;
   text-align: center;
   border-radius: 2.5px;
   max-width: 60px;
   display: flex;
   justify-content: center;
`;
const TLabel = styled(Label)`
   background-color: #ccc;
   max-width: 75px;
`;

const RLabel = styled(Label)`
   background-color: ${(props) => calRewardColor(props.StatusType)};
   max-width: 75px;
`;
const SLabel = styled(Label)`
   //background-color: ${(props) => calShippingColor(props.StatusType)};
   background-color: #fb99ff;
   color: #000;
   max-width: 75px;
`;

const ALabel = styled(Label)`
   background-color: ${(props) => caltActivityColor(props.StatusType)};
   max-width: 75px;
`;

const TBLabel = styled(Label)`
   background-color: ${(props) => (props.StatusType ? '#ff0000' : '#51d600')};
   max-width: 75px;
`;

export const StatusLabel = ({ StatusType, msg }) => (
   <Label StatusType={StatusType}>{msg}</Label>
);

export const ImportLabel = ({ StatusType, msg }) => (
   <ILabel StatusType={StatusType}>{msg}</ILabel>
);

export const TypeLabel = ({ StatusType }) => (
   <TLabel StatusType={StatusType}>
      {StatusType === 1 ? 'Physical' : 'Code/Serial'}
   </TLabel>
);

export const ActLable = ({ StatusType }) => (
   <ALabel StatusType={StatusType}>{StatusType}</ALabel>
);

export const RedeemLabel = ({ StatusType, msg }) => (
   <RLabel StatusType={StatusType}>{msg}</RLabel>
);
export const ShippingLabel = ({ StatusType, msg }) => (
   <SLabel StatusType={StatusType}>{msg}</SLabel>
);

export const TransLabel = ({ StatusType }) => (
   <TBLabel StatusType={StatusType}>{StatusType ? 'ลด' : 'เพิ่ม'}</TBLabel>
);
